import React from 'react';
import cn from 'classnames';

function PlaylistNewCard({ t, currentIndex, clientY, clientX, clientHeight }) {
  return (
    <div
      style={{
        position: 'absolute',
        top: clientY,
        left: clientX,
        height: clientHeight,
        width: '100%',
      }}
      className={cn('playlist-card playlist-card--full')}
    >
      <div className="playlist-card__number">{currentIndex + 1}</div>
      <div className="playlist-card__image--preview" />
      <div className="playlist-card__new-text">{t('drag-for-add')}</div>
    </div>
  );
}

export default PlaylistNewCard;
